import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import Menu from '@material-ui/core/Menu';
import { MenuItem } from '@material-ui/core';
import { useLanguage } from '../../../../../context/LanguageContext';
import { KINDOFBID } from '../../../../../data/constants';

import '../styles.scss';

const CombinedPreferencesRow = (props) => {
  const { labels } = useLanguage();
  const commonLabels = labels.commonLabels || {};
  const PREFERENCE_MENU = labels.PREFERENCE_MENU || {};
  const { 
    preferenceLabel, 
    bidSequence, 
    groupSequence, 
    preferencesLength, 
    movePreference, 
    removeBidFromCombinedPreferences, 
    groupIndex, 
    editPrefFromCombined,
    preferenceOptionId
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuItemsTxt, setMenuItemsTxt] = useState([]);
  const canEditCombinedPreference = preferenceOptionId !== KINDOFBID.COMBINED_PREFERENCE_EDIT_DISABLED_OPTION_ID;

  useEffect(() => {
    setMenuItemsTxt(getMenuItems(preferencesLength, bidSequence, groupSequence))
  }, [preferencesLength, bidSequence, groupSequence, PREFERENCE_MENU, canEditCombinedPreference])

  const getMenuItems = (preferencesLength, bidSequence, groupSequence) => {
    const editItem = canEditCombinedPreference
      ? [{ id:99, text: PREFERENCE_MENU.EDIT, func: () => editPrefFromCombined(groupIndex, bidSequence, preferenceOptionId) }]
      : [];
    const itemsText = preferencesLength === 1 ? [
			{ id: 0, text: PREFERENCE_MENU.DELETE, func: () => removeBidFromCombinedPreferences(groupIndex, bidSequence) },
      ...editItem
		] : preferencesLength  > 1 && bidSequence === 1 ? 
    [
			{ id: 1, text: PREFERENCE_MENU.MOVE_DOWN, func: () => movePreference(groupSequence, bidSequence, "down") },
			{ id: 2, text: PREFERENCE_MENU.DELETE, func: () => removeBidFromCombinedPreferences(groupIndex, bidSequence) },
      ...editItem
    ] : preferencesLength === bidSequence ? 
		[
			{ id: 0, text: PREFERENCE_MENU.MOVE_UP, func: () => movePreference(groupSequence, bidSequence, "up") },
			{ id: 1, text: PREFERENCE_MENU.DELETE, func: () => removeBidFromCombinedPreferences(groupIndex, bidSequence) },
      ...editItem
		] : 
		[
			{ id: 0, text: PREFERENCE_MENU.MOVE_UP, func: () => movePreference(groupSequence, bidSequence, "up") },
			{ id: 1, text: PREFERENCE_MENU.MOVE_DOWN, func: () => movePreference(groupSequence, bidSequence, "down") },
			{ id: 2, text: PREFERENCE_MENU.DELETE, func: () => removeBidFromCombinedPreferences(groupIndex, bidSequence) },
      ...editItem
		] 
		return itemsText;
	};

	const menuItems = [];
	menuItemsTxt?.map(option => menuItems.push(<MenuItem key={`menuItems_${option.id}`} onClick={option.func}>{option.text}</MenuItem>));

	const menu = (
		<Menu
			id="simple-menu"
			anchorEl={anchorEl}
			open={Boolean(anchorEl)}
			onClose={() => handleClose()}
			onClick={() => handleClose()}
			disableScrollLock={false}
		>
			{menuItems }
		</Menu>
	);

	function disable() {
    document.body.style.height = '100%';
    document.body.style.overflowY = 'hidden !important';
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    disable()
  };

  const handleClose = () => setAnchorEl(null);
  return (
    <div className='Combined-Preferences-Row'>
      {preferenceLabel}
      <button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={e => handleClick(e)}
        className='menu-button'
      >
        ...
      </button>
      {menu}
    </div>
  )
}

CombinedPreferencesRow.propTypes = {
  preferenceLabel: PropTypes.string, 
  bidSequence: PropTypes.number, 
  groupSequence: PropTypes.number, 
  preferencesLength: PropTypes.number, 
  movePreference: PropTypes.func, 
  removeBidFromCombinedPreferences: PropTypes.func, 
  groupIndex:  PropTypes.number, 
  editPrefFromCombined: PropTypes.func,
  preferenceOptionId: PropTypes.number
}

export default CombinedPreferencesRow